import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  roles: [],
  loading: false,
  error: null,
  success: false
};

const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearError: (state) => {
      state.error = null;
    },
    setSuccess: (state, action) => {
      state.success = action.payload;
      state.loading = false;
    },
    clearSuccess: (state) => {
      state.success = false;
    },
    setRoles: (state, action) => {
      state.roles = action.payload;
      state.loading = false;
    },
    deleteUser: (state, action) => {
      state.users = state.users.filter(user => user.user_id !== action.payload);
      state.totalUsers -= 1;
    },
  }
});

export const { 
  setLoading, 
  setError, 
  clearError, 
  setSuccess, 
  clearSuccess, 
  setRoles,
  deleteUser
} = adminSlice.actions;

export default adminSlice.reducer;